import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.modelValue == _ctx.name ? 'active' : '', _ctx.type, _ctx.disabled ? 'disabled' : '']),
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.labelOnClick && _ctx.labelOnClick(...args)))
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}